import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import PaymentAuditComp from './PaymentAuditComp';

function PaymentAudit() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <PaymentAuditComp />
      </div>
    </div>
  );
}

export default PaymentAudit;
